import { Article } from './Article';
import { ArticleAttribute } from './ArticleAttribute';

export enum ArticleAttributeAssignmentSlot {
  Genre = 'genre',
  Setting = 'setting',
  Character = 'character',
}

export type ArticleAttributeAssignment = {
  id: string;
  slot: ArticleAttributeAssignmentSlot;
  articleId: string;
  article?: Article;
  attributeId: string;
  attribute?: ArticleAttribute;
};
